import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text
} from "@chakra-ui/react";
import React from "react";
import { pxToRem } from "../../../utils/editor.ts";

const ErrorDetailModal: React.FC<{
  errorInfo: string,
  setShowError: (show: boolean) => void
}> = ({ errorInfo, setShowError }) => {

  const closeModal = () => {
    setShowError(false)
  };

  return (
      <Modal
        isOpen={true}
        onClose={closeModal}
        closeOnOverlayClick={false}
        isCentered
    
      >
        <ModalOverlay bg={"rgba(0, 0, 0, 0.1)"} />
        <ModalContent
          maxW={pxToRem(866)}
          height={pxToRem(600)}
          bg={"white"}
          borderRadius={pxToRem(24)}
          boxShadow="none"
          p={10}
        >
          <ModalCloseButton
            _focusVisible={{ boxShadow: "none" }}
            color={"#666"}
            top={pxToRem(12)}
            right={pxToRem(12)}
            fontSize={pxToRem(14)}
            borderRadius={"50%"}
          />
          <ModalBody p={0}
            w={pxToRem(1200)}
            height={pxToRem(550)}
            overflow={"auto"}
          >
          <Text margin={0} fontSize={'1rem'} fontFamily={'Lato'} whiteSpace="pre-wrap"> {errorInfo}</Text>
          </ModalBody>
        </ModalContent>
      </Modal>
  );
};

export default ErrorDetailModal;
